module.exports = __webpack_public_path__ + "static/img/logo-cn.9a26ee5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logo-cn.png
// module id = Gmb9
// module chunks = 1